import { render, staticRenderFns } from "./FacebookRaw.vue?vue&type=template&id=28341686&"
import script from "./FacebookRaw.vue?vue&type=script&lang=js&"
export * from "./FacebookRaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports